/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { AnalyticsBrowser } from '@segment/analytics-next'
import { getEnv } from './environment'

declare global {
  interface Window {
    analytics?: AnalyticsBrowser
  }
}

export function initializeAnalytics() {
  // Only initialize on client side. Skip if already setup.
  if (typeof window === 'undefined' || (window as any).analytics) {
    return
  }

  const apiHost = getEnv('NEXT_PUBLIC_SEGMENT_URL')
  if (!apiHost) {
    return
  }

  const apiKey = getEnv('NEXT_PUBLIC_SEGMENT_API_KEY') || ''
  const protocol = getEnv('NEXT_PUBLIC_SEGMENT_PROTOCOL') || 'https'
  const analytics = AnalyticsBrowser.load({
    writeKey: apiKey,
    cdnSettings: {
      integrations: {
        'Segment.io': {
          apiHost,
          apiKey,
          protocol,
        },
      },
      // Metrics are the /m events sent directly to Segment (not our proxy).
      // If api key is set, then use metrics defaults. Otherwise disable.
      ...(apiKey ? {} : { metrics: { sampleRate: 0 } }),
    },
  })

  ;(global as any).analytics = analytics
  ;(window as any).analytics = analytics
}
